import SPress from "./SPress_web"
export default SPress
